/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import { IEmployeeRouteSwitcherData } from './employee-route-switcher.data';
import { IEmployeeRouteSwitcherProps } from './employee-route-switcher.props.autogenerated';

/**
 *
 * EmployeeRouteSwitcher component
 * @extends {React.PureComponent<IEmployeeRouteSwitcherProps<IEmployeeRouteSwitcherData>>}
 */
class EmployeeRouteSwitcher extends React.PureComponent<IEmployeeRouteSwitcherProps<IEmployeeRouteSwitcherData>> {
    constructor(props: IEmployeeRouteSwitcherProps<IEmployeeRouteSwitcherData>) {
        super(props);
    }

    public componentDidMount(): void {
        void this._startRerouteProcess();
    }

    public render(): JSX.Element | null {
        return <div />;
    }

    private async _startRerouteProcess(): Promise<void> {
        const userCtx = this.props.context.request.user;
        const { loginLink, verificationLink } = this.props.config;
        const isLoggedIn = userCtx.isAuthenticated && userCtx.customerAccountNumber;

        if (window.location.hostname === 'manage.commerce.dynamics.com') { return; }

        // if not logged in, and login url is set - route to login / signup page
        if (loginLink && !isLoggedIn) {
            window.location.replace(loginLink.destinationUrl);
        }

        const isVerified = await this._isVerified();
        // if logged in, and the verification url is set, and the user is not verified - send them to the verification
        // page
        if (isLoggedIn && verificationLink && !isVerified) {
            window.location.replace(verificationLink.destinationUrl);
        }
    }

    private async _isVerified(): Promise<boolean> {
        const customer = await this.props.data.customer;

        // verification currently just means they have zero affiliations. might need stronger logic later
        return !!(customer.CustomerAffiliations && customer.CustomerAffiliations.length > 0);
    }
}

export default EmployeeRouteSwitcher;
